import Vue from "vue";
import Router from 'vue-router';
import store from "@/store/store.js";

Vue.use(Router);
// 我的预约
const appointment = () => import("@/components/appointment/index");
const newPage = () => import("@/pages/newPage");
// 预约 问诊详情
const appYy = () => import("@/components/appointment/appYy");
const helloWorld = () => import("@/components/HelloWorld.vue");
const prescription = () => import("@/components/prescription/index.vue")
// 处方模版
const prescriptionTemplateForm = () => import("@/components/prescription/template/form.vue")
const prescriptionTemplateList = () => import("@/components/prescription/template/list.vue")
//登录
const login = () => import("@/components/login/index");
//服务协议界面
const protocol = () => import("@/components/login/protocol");
// 设置密码/修改密码
const setPass = () => import("@/components/login/setPass");
// 咨询小结
const consultationSummary = () =>
  import("@/components/chat/consultSummary");

// 检验报告
const checkReport = () =>
  import("@/components/chat/checkReport");
// 检验报告
const rightIframe = () =>
  import("@/components/chat/rightIframe");
// 患者档案
const profile = () =>
  import("@/components/chat/profile");
// 电子病历
const electron = () =>
  import("@/components/chat/electron");
// 快捷回复
const quickReply = () =>
  import("@/components/chat/quickReply");
// 门诊病历
const outpatientEmr = () =>
  import("@/components/chat/outpatientEmrBrief");
// 门诊病历详情
const outpatientEmrDetail = () =>
  import("@/components/chat/outpatientEmrDetail");

//审方首页
const trialPartyIndex = () => import("@/components/trialParty/index");
//自动审方
const preAuto = () => import("@/components/trialParty/preAuto");
//审方我的
const pharmacistFoo = () => import("@/components/trialParty/pharmacistFoo");
//审方待审核详情
const pharmWait = () => import("@/components/trialParty/pharmWait");
//审核通过详情
const pharmDetail = () => import("@/components/trialParty/pharmDetail");
//审方不通过
const noPass = () => import("@/components/trialParty/noPass");
//不通过理由选择
const noPassChoose = () => import("@/components/trialParty/noPassChoose");
//诊疗记录详情
const recordDetail = () => import("@/components/trialParty/recordDetail");

// 我的（首页）
const myIndex = () => import("@/components/my/index");
// 设置（我的）
const myFit = () => import("@/components/my/myFit");
// 我的审方
const myAuditor = () => import("@/components/my/myAuditor");
//我的历史处方
const myHisRecipel = () => import("@/components/my/myHisRecipel");
// 本次处方详情
const prescDetail = () => import("@/components/appointment/prescDetail");
//历史处方待支付详情
const waitPay = () => import("@/components/prescription/waitPay");
//查看电子处方
const electronicPrescription = () =>
  import("@/components/prescription/electronicPrescription");
  // 本次处方待审核及已通过详情
const waitPassPerSetail = () =>
  import("@/components/appointment/waitPassPerSetail");
  // 资料服务
const information = () => import("@/components/appointment/information");
// 我的历史处方详情页面
const historyCfDetail = () => import("@/components/my/historyCfDetail");
// 环信历史记录信息
const hxHistoryInfo = () => import("@/components/chat/hxHistoryRecords");
// 认证
const certification = () => import("@/components/my/certification")
// 签名
const signature = () => import("@/components/my/signature")
// 活动二维码
const activeQrcode = () => import("@/components/my/activeQrcode")
// 抢单区列表
const grabOrderList = () => import("@/components/appointment/orderGrabList.vue")
// 新增病情消息
const addCondition = () => import("@/components/chat/components/addCondition.vue")
// 实名认证页
const realNameAuth = () => import("@/components/realNameAuth/authIndex.vue")
// 认证结果页
const authResult = () => import("@/components/realNameAuth/authResult.vue")


// let docInfo = myJsTools.getItem("docInfo");

const routes = [
  {
      path: "/",
    redirect: to => {
        return "index";
        // }
      }
    },
    {
      path: "/index",
      name: "index",
      component: helloWorld,
      meta: {
        title: '在线诊室',
        keepAlive: false, 
        requireAuth: true
      },
      // beforeEnter: (to, from, next) => {
      //   // 在进入该路由之前的逻辑
      //   console.log('Before entering index page');
      //   if (docInfo == "all" || docInfo == 'doc') {
      //     myJsTools.setItem('activeTabbar', 0)
      //   }
      //   next();
      // }
  },
    {
      path: "/newPage",
      name: "newPage",
      component: newPage,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/appointment",
      name: "appointment",
      component: appointment,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/appYy",
      name: "appYy",
      component: appYy,
      meta: {keepAlive: false, requireAuth: true}
    },
    // {
    //   path: '/imList',
    //   name: "helloWorld",
    //   component: helloWorld,
    //   meta: {keepAlive: false, requireAuth: true}
    // },
    {
     path: "/prescription",
      name: "prescription",
      component: prescription,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/prescriptionTemplateForm",
       name: "prescriptionTemplateForm",
       component: prescriptionTemplateForm,
       meta: {keepAlive: false, requireAuth: true}
     },
     {
      path: "/prescriptionTemplateList",
       name: "prescriptionTemplateList",
       component: prescriptionTemplateList,
       meta: {keepAlive: false, requireAuth: true}
     },
    {
      path: "/consultationSummary",
      name: "consultationSummary",
      component: consultationSummary,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/checkReport",
      name: "checkReport",
      component: checkReport,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/rightIframe",
      name: "rightIframe",
      component: rightIframe,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/profile",
      name: "profile",
      component: profile,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/electron",
      name: "electron",
      component: electron,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/quickReply",
      name: "quickReply",
      component: quickReply,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/outpatientEmr",
      name: "outpatientEmr",
      component: outpatientEmr,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/outpatientEmrDetail",
      name: "outpatientEmrDetail",
      component: outpatientEmrDetail,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/login",
      name: "login",
      component: login,
      meta: {keepAlive: false, requireAuth: true}
  },
    {
      path: "/protocol",
      name: "protocol",
      component: protocol,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/setPass",
      name: "setPass",
      component: setPass,
      meta: {keepAlive: false, requireAuth: true}
  },
    {
      path: "/trialPartyIndex",
      name: "trialPartyIndex",
      component: trialPartyIndex,
      meta: {
        title: '审方',
        keepAlive: false, 
        requireAuth: true, 
      },
      // beforeEnter: (to, from, next) => {
      //   // 在进入该路由之前的逻辑
      //   console.log('Before entering trialPartyIndex page');
      //   if (docInfo == "all") {
      //     myJsTools.setItem('activeTabbar', 1)
      //   } else if ( docInfo == 'drugDoc') {
      //     myJsTools.setItem('activeTabbar', 0)
      //   }
      //   next();
      //   // if (myJsTools.getItem("token_info")) {
      //   //   next();
      //   // } else {
      //   //   next("/login");
      //   // }
      // }
    },
    {
      path: "/pharmacistFoo",
      name: "pharmacistFoo",
      component: pharmacistFoo,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/preAuto",
      name: "preAuto",
      component: preAuto,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/pharmWait",
      name: "pharmWait",
      component: pharmWait,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/pharmDetail",
      name: "pharmDetail",
      component: pharmDetail,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/noPass",
      name: "noPass",
      component: noPass,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/noPassChoose",
      name: "noPassChoose",
      component: noPassChoose,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/recordDetail",
      name: "recordDetail",
      component: recordDetail,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/myIndex",
      name: "myIndex",
      component: myIndex,
      meta: {
        title: '我的',
        keepAlive: false, 
        requireAuth: true
      },
      // beforeEnter: (to, from, next) => {
      //   // 在进入该路由之前的逻辑
      //   console.log('Before entering myIndex page');
      //   if (docInfo == "all") {
      //     myJsTools.setItem('activeTabbar', 2)
      //   } else if (docInfo == 'drugDoc' || docInfo == 'doc') {
      //     myJsTools.setItem('activeTabbar', 1)
      //   }
      //   // myJsTools.setItem('activeTabbar', 2)
      //   next();
      // }
    },
    {
      path: "/myFit",
      name: "myFit",
      component: myFit,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/myAuditor",
      name: "myAuditor",
      component: myAuditor,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/myHisRecipel",
      name: "myHisRecipel",
      component: myHisRecipel,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/prescDetail",
      name: "prescDetail",
      component: prescDetail,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/waitPay",
      name: "waitPay",
      component: waitPay,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/electronicPrescription",
      name: "electronicPrescription",
      component: electronicPrescription,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/waitPassPerSetail",
      name: "waitPassPerSetail",
      component: waitPassPerSetail,
      meta: {keepAlive: false, requireAuth: true}
    },
     {
      path: "/information",
      name: "information",
      component: information,
      meta: {keepAlive: false, requireAuth: true}
    },
     {
      path: "/historyCfDetail",
      name: "historyCfDetail",
      component: historyCfDetail,
      meta: {keepAlive: false, requireAuth: true}
  },
     {
      path: "/hxHistoryInfo",
      name: "hxHistoryInfo",
      component: hxHistoryInfo,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/signature",
      name: "signature",
      component: signature,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/certification",
      name: "certification",
      component: certification,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/activeQrcode",
      name: "activeQrcode",
      component: activeQrcode,
      meta: {keepAlive: false, requireAuth: true}
    },
    {
      path: "/grabOrderList",
      name: "grabOrderList",
      component: grabOrderList,
      meta: {
        title: '抢单区',
        keepAlive: false, 
        requireAuth: true
      }
    },
    {
      path: "/addCondition",
      name: "addCondition",
      component: addCondition,
      meta: {
        title: '新增病情消息',
        keepAlive: false, 
        requireAuth: true
      }
    },
    {
      path: "/realNameAuth",
      name: "realNameAuth",
      component: realNameAuth,
      meta: {
        title: '本人实名认证',
        keepAlive: false, 
        requireAuth: true
      }
    },
    {
      path: "/authResult",
      name: "authResult",
      component: authResult,
      meta: {
        title: '本人实名认证',
        keepAlive: false, 
        requireAuth: true
      }
    },
  ]

const router = new Router({
  routes,
   mode: 'hash'
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
  // 如果路由配置了meta.title，则使用该标题,否则使用"医生端"
  if (to.meta.title) {
    document.title = to.meta.title
  } else {
    // 这里可以显式设置默认标题，与index.html保持一致
    document.title = '医生端'
  }
  if(to.name == 'index'){
    store.commit('msg/CLOSE_MSG', 'new_order_remind')
  }
  next() // 必须调用next()才能继续路由跳转
})

export default router